export default {
    background: "var(--veryLightGray)",
    backgroundSecond: "var(--white)",
    color: "var(--veryDarkBlue)",
    boxShadow: "1px 1px 10px  hsla(0, 0%, 52%, 0.219)",
    magnefierColor: "var(--darkGray)", 
 }